import { Component, Input, OnInit } from '@angular/core';
import { DocumentModel } from '../../model/DocumentModel';

@Component({
  selector: 'app-liste-documents',
  templateUrl: './liste-documents.component.html',
  styleUrls: ['./liste-documents.component.scss']
})
export class ListeDocumentsComponent implements OnInit {
  @Input()
  listeDocs: DocumentModel[];

  constructor() {}

  ngOnInit() {}

}
